<template>
    <static-layout>
        <template v-slot:header>
            <Header title="Pagina Template"/>
        </template>
        <template>
            <div class="template-content">
                <div class="item mb-3">
                    <h1>Solo testo</h1>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue. Habitant morbi tristique senectus et netus et malesuada fames. Blandit massa enim nec dui nunc mattis enim ut. Turpis massa tincidunt dui ut. Ultrices tincidunt arcu non sodales neque sodales ut etiam. Facilisis mauris sit amet massa vitae tortor condimentum. Nunc faucibus a pellentesque sit amet porttitor eget. Orci a scelerisque purus semper eget duis at tellus at. Tellus at urna condimentum mattis pellentesque id nibh tortor id.
                    </p>
                </div>
                <div class="item mb-3">
                    <h3>Sottotitolo 1</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue. Habitant morbi tristique senectus et netus et malesuada fames. Blandit massa enim nec dui nunc mattis enim ut. Turpis massa tincidunt dui ut. Ultrices tincidunt arcu non sodales neque sodales ut etiam. Facilisis mauris sit amet massa vitae tortor condimentum. Nunc faucibus a pellentesque sit amet porttitor eget. Orci a scelerisque purus semper eget duis at tellus at. Tellus at urna condimentum mattis pellentesque id nibh tortor id.
                    </p>
                    <ul>
                        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut.</li>
                        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue.</li>
                    </ul>
                </div>
                <div class="item image my-5"></div>
                <div class="item d-flex image-text my-5">
                    <div class="image">
                        <div></div>
                    </div>
                    <div class="text">
                        <h3>Solo testo</h3>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id donec ultrices tincidunt arcu non sodales neque sodales ut. Tincidunt lobortis feugiat vivamus at augue. Habitant morbi tristique senectus et netus et malesuada fames. Blandit massa enim nec dui nunc mattis enim ut. Turpis massa tincidunt dui ut. Ultrices tincidunt arcu non sodales neque sodales ut etiam. Facilisis mauris sit amet massa vitae tortor condimentum. Nunc faucibus a pellentesque sit amet porttitor eget. Orci a scelerisque purus semper eget duis at tellus at. Tellus at urna condimentum mattis pellentesque id nibh tortor id.
                        </p>
                    </div>
                </div>
                <div class="adjust">
                    <CarouselOne :max=2>
                        <slide>
                            <div class="d-flex slide-image">
                                <div>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="d-flex slide-image">
                                <div>
                                </div>
                            </div>
                        </slide>
                    </CarouselOne>
                </div>
            </div>
        </template>
        <template v-slot:footer>
        </template>
    </static-layout>
</template>

<script>
import StaticLayout from './layout/StaticLayout'
import Footer from './layout/common/Footer'
import Header from './layout/static/Header'
import CarouselOne from '../widgets/common/CarouselOne'
import TopInfo from '../widgets/pages/detail/TopInfo'
import ProssimiTour from '../widgets/pages/home/ProssimiTour'
export default {
  name: 'Detail',
  components: {ProssimiTour, TopInfo, CarouselOne, Header, Footer, StaticLayout}
}
</script>

<style scoped>
    .adjust {
        margin-left: 80px;
        margin-bottom: 50px;
    }
    .map {
        width: 100%;
        height: 430px
    }
</style>



// WEBPACK FOOTER //
// src/front/components/pages/Template.vue